<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานพฤติมาตร 
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <!-- <router-link to="/Admin/User_behavior"> -->
            <i class="fa fa-dashboard"></i> รายงานพฤติมาตร
          <!-- </router-link> -->
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทข้อมูลที่ต้องการค้นหา" class="is-required">
                            <el-select
                              v-model="form.data_type"
                              placeholder="กรุณาเลือกประเภทข้อมูลที่ต้องการค้นหา"
                            >
                              <el-option label="ค่าเฉลี่ยจำนวนครั้งการโทรออกต่อวัน" value="outgoing_call"></el-option>
                              <el-option label="ค่าเฉลี่ยจำนวนครั้งการส่ง sms ต่อวัน" value="sms_send"></el-option>
                              <el-option label="ค่าเฉลี่ยจำนวนครั้งการส่ง mms ต่อวัน" value="mms_send"></el-option>
                              <el-option label="ค่าเฉลี่ยการดาวน์โหลดข้อมูลต่อวัน" value="download_bytes"></el-option>
                              <el-option label="ค่าเฉลี่ยการอัปโหลดข้อมูลต่อวัน" value="upload_bytes"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="ช่วงเวลาที่ค้นหา" class="is-required">
                                <el-date-picker
                                    v-model="form.date_range"
                                    type="daterange"
                                    range-separator="ถึง"
                                    start-placeholder="วันที่เริ่มต้น"
                                    end-placeholder="วันที่สิ้นสุด"
                                ></el-date-picker>    
                            </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="displayChart">
                <div class="col-sm-12" style="text-align:right;">
                  <el-button type="primary" @click.prevent="exportDoc">Export Word</el-button>
                </div>
              </div>
              <div id="chart" class="box-body" ref="chart" style="min-height: 500px;" v-if="displayChart">
                <div class="col-sm-12">
                  <charts class="chart" style="padding-top : 50px; max-height: 500px;" :options="this.store_chart" ></charts>
                </div>
              </div>
              <div class="box-body" v-if="displayText">
                <div class="col-sm-12">
                  <h4 align="center">ไม่พบข้อมูลที่ต้องการค้นหา</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import Chart from "chart.js"
import { mapState, mapActions } from "vuex";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom } from "docx";
import { saveAs } from "file-saver";
const moment = require("moment");
export default {
  data() {
    return {
      showReport: null,
      label_position: "top",
      form: {
        date_range: [],
        data_type: '',
      }
    };
  },
  computed : {
    ...mapState({
        store_chart: store => store.UtelemeStore.chart,
        displayChart: store => store.UtelemeStore.displayChart,
        displayText: store => store.UtelemeStore.displayText
    })
  },
  mounted() {},
  watch: {
      
  },
  methods: {
    ...mapActions({
      searching: 'UtelemeStore/getUtelemeStats'
    }),
    clear_data() {
      this.form.type_data = {
          
      };
    },
    change_provider() {
      this.form.search_type = ""
    },
    find_chart() {
      if (this.form.data_type == '') {
        this.$alert("กรุณาเลือกประเภทข้อมูลที่ต้องการค้นหา", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      } else if (this.form.date_range.length == 0 || this.form.date_range.length == '') {
        this.$alert("กรุณาเลือกช่วงเวลาที่ค้นหา", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      } else {
        this.showReport = true
        this.searching(this.form)
      }
    },
    exportDoc(){
      this.$html2canvas(this.$refs.chart, { canvas: null }).then(function(canvas) { console.log(canvas) })
      this.$html2canvas(this.$refs.chart, { 
        canvas: null, 
        onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } 
      }).then(function(canvas) {
        const img = canvas.toDataURL("image/png", 1.0);
        const doc = new Document();
        // const image = Media.addImage(doc, img, canvas.width/4, canvas.height/4);
        const image = Media.addImage(doc, img, 920, 400,{
          floating: {
            verticalPosition: {
              relative: VerticalPositionRelativeFrom.PAGE,
              offset: 2014400,
            },
            horizontalPosition: {
              align: HorizontalPositionAlign.CENTER
            }
          }
        });
        doc.addSection({
          size: {
            orientation: PageOrientation.LANDSCAPE,
          },
          children: [new Paragraph(image)],
        });
        Packer.toBlob(doc).then(blob => {
          saveAs(blob, "report.docx");
        });
      });
    }
  }
};
</script>
